'use strict';

// ---------- Image / css assets ------------

require.context('./assets/', true, /\.(svg|png|jpe?g)$/);
require('./assets/styles/main.scss');

// ---------- js assets ------------

require('./assets/scripts/components/books.js');
require('./assets/scripts/components/gift.js');
require('./assets/scripts/components/product.js');
require('./assets/scripts/components/collection.js');
require('./assets/scripts/components/blog.js');
require('./assets/scripts/components/cart.js');
require('./assets/scripts/components/header.js');
require('./assets/scripts/components/footer.js');
require('./assets/scripts/components/index-gsap.js');
require('./assets/scripts/components/addToCart.js');
require('./assets/scripts/components/imageWall.js');
